module.exports = __webpack_public_path__ + "assets/img/20_965.ecb28f11.jpg";